import React, { useEffect, useState } from 'react';
import { DashboardApis } from 'hooks/apis/DashboardApis';
import { formatCurrency } from 'helpers/numberFormats';
import { IClientTileProps } from 'interfaces/Dashboard/IClientTileProps';
import StatTile from '../../../components/common/StatTile';

const ClientSpendTile = ({clientReference, limsDatabase}: IClientTileProps) => {
  const [value, setValue] = useState<number | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const { getClientTotalSpend } = DashboardApis();

  useEffect(() => {
    getClientTotalSpend(clientReference, limsDatabase)
      .then((data) => {
        if (data && !data.errorMessage) {
          setValue(data);
        } else if (data?.errorMessage) {
          setError(data.errorMessage);
        }
      })
      .finally(() => setLoading(false));
  }, [getClientTotalSpend, clientReference, limsDatabase]);

  return (
    <StatTile
      label="Total Customer Spend"
      value={value !== null ? formatCurrency(value) : '-'}
      loading={loading}
      error={error}
    />
  );
};

export default ClientSpendTile;